import { getDataForChart } from '../../../utils/reactChartConfig'
import { CONSTRUCTS } from '../../../utils/constructs'
import { convert1to6ToPercent } from '../../../utils/statisticCalc'

/**
 * called by ResultsModule3.js
 * @param jtLabels, object, 'label' portion of the jsonText object from Redux
 * @param modNpoAnswers, object, latest NPO survey answers for current module
 * @param benchMod, object, benchmark of either this NPO category or of all NPOs
 * @param modResults, object, the latest results of the user's organization with respect to above benchmark (percentiles)
 * @param benchType, string, benchmark chartType, either 'cat' or 'all'
 * @param yearlyComp, object, containing all the info and data for a yearly comparison (or null)
 * @param chartType, string, either 'summary' (overall result) or the section name (not yet used)
 * @return object, the chart data for Module 3
 *
 * Note: for yearly comparison, we use the following variables slightly differently:
 * modNpoAnswers = benchmark, either for all NPOs ('all') or only the NPOs of the same category ('cat')
 * benchMod = last survey results
 * modResults = results of selected year's survey (or null)
 * benchType = always null
 */
export const getChartDataMod3 = (jtLabels, modNpoAnswers, benchMod, modResults, benchType, yearlyComp, chartType) => {
  if (yearlyComp) {
    modNpoAnswers = yearlyComp.benchmark
    benchMod = yearlyComp.lastSurveyResults
    modResults = yearlyComp.selectedSurveyResults
    benchType = null
  }
  let chartLabels, npoData, benchData, resultsData
  switch (chartType) {
    case 'summary':
      chartLabels = [  // the order here pertains only to the chart
        `${jtLabels[CONSTRUCTS.CONSENSUS.name] || 'Consensus'}`.toUpperCase(),
        `${jtLabels[CONSTRUCTS.STRATEGY.name] || 'Strategy'}`.toUpperCase(),
        `${jtLabels[CONSTRUCTS.COMMUNICATION.name] || 'Communication'}`.toUpperCase(),
        `${jtLabels[CONSTRUCTS.HR_DIVERSITY.name] || 'hrDiversity'}`.toUpperCase(),
        `${jtLabels[CONSTRUCTS.HR_LOYALTY.name] || 'hrLoyalty'}`.toUpperCase(),
      ]
      npoData = [
        modNpoAnswers?.KON.mean,
        modNpoAnswers?.STR.mean,
        modNpoAnswers?.IKM.mean,
        modNpoAnswers?.HRD.mean,
        modNpoAnswers?.HRB.mean,
      ]
      benchData = [
        benchMod?.KON.mean,
        benchMod?.STR.mean,
        benchMod?.IKM.mean,
        benchMod?.HRD.mean,
        benchMod?.HRB.mean,
      ]
      if (yearlyComp) resultsData = [
        modResults?.KON.percentile,
        modResults?.STR.percentile,
        modResults?.IKM.percentile,
        modResults?.HRD.percentile,
        modResults?.HRB.percentile,
      ]
      break
    default:
      console.error('No match found for chart chartType:', chartType)
  }

  return getDataForChart(jtLabels, chartLabels, npoData, benchData, resultsData, benchType, yearlyComp)
}
